import React, {Fragment} from 'react';

import {Box, Typography} from '@mui/material';
import {motion} from 'motion/react';
import {
	CIRCULAR_PROGRESS_CIRCUMFERENCE,
	CIRCULAR_PROGRESS_RADIUS,
	CIRCULAR_PROGRESS_STROKE_WIDTH,
	PROFILE_PROGRESS_THRESHOLDS,
} from '../constants';
import {ProgressContainer, StyledBox} from '../styles';
import {CircularProgressProps} from '../types';
import {getProgressColor} from '../utils/getProgressColor';

export const CircularProgress = ({progress, size = 40}: CircularProgressProps) => {
	const strokeDashoffset =
		CIRCULAR_PROGRESS_CIRCUMFERENCE -
		(progress / PROFILE_PROGRESS_THRESHOLDS.MAX) * CIRCULAR_PROGRESS_CIRCUMFERENCE;

	const progressPercentage = Math.round(progress);

	return (
		<ProgressContainer $size={size}>
			<Fragment>
				<svg
					width={size}
					height={size}
					viewBox="0 0 40 40"
					fill="none"
					style={{display: 'block'}}>
					<circle
						cx="20"
						cy="20"
						r={CIRCULAR_PROGRESS_RADIUS}
						stroke="black"
						strokeOpacity="0.07"
						strokeWidth={CIRCULAR_PROGRESS_STROKE_WIDTH}
						fill="none"
					/>
				</svg>

				<StyledBox>
					<Typography variant="caption" color="text.primary" fontWeight={600}>
						{progressPercentage}%
					</Typography>
				</StyledBox>
				<Box
					sx={{
						position: 'absolute',
						left: '2px',
						top: '2px',
						width: '36px',
						height: '36px',
					}}>
					<Box sx={{position: 'absolute', inset: '-5.56%'}}>
						<svg
							width={size}
							height={size}
							viewBox="0 0 40 40"
							fill="none"
							style={{
								display: 'block',
								transform: 'rotate(-90deg)',
							}}>
							<motion.circle
								cx="20"
								cy="20"
								r={CIRCULAR_PROGRESS_RADIUS}
								fill="none"
								stroke={getProgressColor(progress)}
								strokeWidth={CIRCULAR_PROGRESS_STROKE_WIDTH}
								strokeDasharray={CIRCULAR_PROGRESS_CIRCUMFERENCE}
								strokeDashoffset={strokeDashoffset}
								strokeLinecap="round"
								animate={{
									strokeDashoffset,
									stroke: getProgressColor(progress),
								}}
								transition={{duration: 0.5, ease: 'easeOut'}}
							/>
						</svg>
					</Box>
				</Box>
			</Fragment>
		</ProgressContainer>
	);
};
